import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons } from '../icons';

var tourId;
export default class TourRoute extends Component {

    componentWillMount() {

        let map = this.props.gMap;
        let tour = this.props.tour;
        tourId = tour.id;
        let routeObjects = [];
            let polylines = this.props.route.polylines;
            polylines.forEach(function(polyline, lineIndex){
                let pointList = [];
                polyline.path.forEach(function(point, pointIndex){


                    if (point.latitude) {
                        pointList.push({lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)});
                    } else {
                        pointList.push({lat: parseFloat(point[1]), lng: parseFloat(point[0])});
                    }

                    if ((lineIndex == 0 && pointIndex == 0) || (polylines.length-1 == lineIndex && polyline.path.length-1 == pointIndex)) {
                        var marker = new google.maps.Marker({
                            position: {lat: (point.latitude)?parseFloat(point.latitude):parseFloat(point[0]), lng: (point.longitude)?parseFloat(point.longitude):parseFloat(point[0])},
                            map: null,
                            icon: {
                                url: icons.start_point,

                                size: new google.maps.Size(28, 28),
                                anchor: new google.maps.Point(14, 14)
                            }
                        });
                        routeObjects.push(marker);


                    }
                });



                let path = new google.maps.Polyline({
                    path: pointList,
                    geodesic: true,
                    strokeColor: '#fff',
                    strokeOpacity: 1,
                    strokeWeight: 7
                });

                path.setMap(map);
                routeObjects.push(path);

                //console.info(polyline);
                //console.info(pointList);

            });

           //console.info('path');
            google.maps.event.trigger(map, "resize");



        this.routeObjects = routeObjects;
    }
    componentDidUpdate() {
        let scrollOptions = this.props.scroll;
        this.routeObjects.forEach(function(object){
            object.setOptions({strokeOpacity: scrollOptions.opacity, opacity: scrollOptions.opacity});
        });

        if (this.props.tour.id !== tourId) {
            tourId = this.props.tour.id;
            if (this.routeObjects) {
                this.routeObjects.forEach(function (object) {
                    object.setMap(null);
                });
            }


            let map = this.props.gMap;
            let tour = this.props.tour;
            tourId = tour.id;
            let routeObjects = [];
            let polylines = this.props.route.polylines;
            polylines.forEach(function(polyline, lineIndex){
                let pointList = [];
                polyline.path.forEach(function(point, pointIndex){


                    if (point.latitude) {
                        pointList.push({lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)});
                    } else {
                        pointList.push({lat: parseFloat(point[1]), lng: parseFloat(point[0])});
                    }

                    if ((lineIndex == 0 && pointIndex == 0) || (polylines.length-1 == lineIndex && polyline.path.length-1 == pointIndex)) {
                        var marker = new google.maps.Marker({
                            position: {lat: (point.latitude)?parseFloat(point.latitude):parseFloat(point[0]), lng: (point.longitude)?parseFloat(point.longitude):parseFloat(point[0])},
                            map: null,
                            icon: {
                                url: icons.start_point,

                                size: new google.maps.Size(28, 28),
                                anchor: new google.maps.Point(14, 14)
                            }
                        });
                        routeObjects.push(marker);


                    }
                });



                let path = new google.maps.Polyline({
                    path: pointList,
                    geodesic: true,
                    strokeColor: '#fff',
                    strokeOpacity: 1,
                    strokeWeight: 7
                });

                path.setMap(map);
                routeObjects.push(path);

                //console.info(polyline);
                //console.info(pointList);

            });

            //console.info('path');
            google.maps.event.trigger(map, "resize");



            this.routeObjects = routeObjects;
        }
    }
    componentWillUnmount() {
        if (this.routeObjects) {
            this.routeObjects.forEach(function (object) {
                object.setMap(null);
            });
        }
    }

    render () {

        return (
            <div>

            </div>



        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/map/TourRoute.js